import {generateSeoInfo} from '../../modules/seo/seoUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

function generateDefaultInitialCampaignState() {
  return {
    campaignBreadcrumbArray: null,
    campaignSeoInfo: null,
    campaignWebtrekkData: null,
    campaignBlocks: null,
    campaignTagInfo: null,
    activeCampaignTagInfo: null,
    campaignPaginationParams: {
      pageNumber: 1,
    },
    initialPageNumber: null,
    customerSpecialCampaign: {}
  };
}

function campaignReducer(state = generateDefaultInitialCampaignState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_CAMPAIGNS_FULFILLED': {
      const {
        breadcrumbs,
        seoInformation: rawSeoInformation,
        webTrekModel: webtrekkData,
        activeTag,
        campaigns,
        campaignsSummary,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        campaignBreadcrumbArray: breadcrumbs,
        campaignSeoInfo: generateSeoInfo(rawSeoInformation),
        campaignWebtrekkData: webtrekkData,
        campaignBlocks: campaigns,
        campaignTagInfo: campaignsSummary,
        activeCampaignTagInfo: activeTag,
        campaignPaginationParams: {
          ...state.campaignPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        initialPageNumber: action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE],
      };
      break;
    }

    case 'GET_CUSTOMER_SPECIAL_CAMPAIGNS_FULFILLED': {
      const customerSpecialCampaign = action.payload.response.data || {}

      newState = {
        ...state,
        customerSpecialCampaign,
      };

      break;
    }

    case 'GET_NEXT_CAMPAIGNS_FULFILLED': {
      const {
        seoInformation: rawSeoInformation,
        webTrekModel: webtrekkData,
        campaigns,
      } = action.payload.response.data.data;

      state.campaignBlocks[0].campaigns = state.campaignBlocks[0].campaigns.concat(campaigns[0].campaigns);

      newState = {
        ...state,
        campaignSeoInfo: generateSeoInfo({
          ...rawSeoInformation,
          h2: state.campaignSeoInfo.h2,
          seoParagraph: state.campaignSeoInfo.seoParagraph,
        }),
        campaignWebtrekkData: webtrekkData,
        campaignBlocks: state.campaignBlocks,
        campaignPaginationParams: {
          ...state.campaignPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
      };
      break;
    }

    case 'LEAVE_CAMPAIGN_PAGE_ROUTE': {
      newState = {
        ...state,
        campaignBreadcrumbArray: null,
        campaignSeoInfo: null,
        campaignWebtrekkData: null,
        campaignBlocks: null,
        campaignTagInfo: null,
        activeCampaignTagInfo: null,
        campaignPaginationParams: {
          pageNumber: 1,
        },
        initialPageNumber: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default campaignReducer;
export {generateDefaultInitialCampaignState};
